// extracted by mini-css-extract-plugin
module.exports = {"productDetails":"_1DWWf","productDetailsHideOnHover":"_3ksPU _35A94","leftText":"_14QyI","centerText":"PniyK","rightText":"_2cfAR"};